import { min, max, required, validate } from 'labguard-cdk'

const maxSampling = max(100000)
const maxActivationEnergy = max(10000)
const minSampling = min(1)
const minActivationEnergy = min(0)

export const validateMkt = ({ activationEnergy, sampling }) => ({
  sampling: validate([required, maxSampling, minSampling])(sampling),
  activationEnergy: validate([required, maxActivationEnergy, minActivationEnergy])(activationEnergy),
})
